import { clientsReducer } from 'modules/client/store/clients';
import contacts from 'modules/contact/store/contacts-slice';
import customers from 'modules/customer/store/customers-slice';
import customerSelect from 'modules/customer/store/customerSelect-slice';
import inbox from 'modules/inbox/store/inbox-slice';
import { projectsReducer } from 'modules/project/store/project';
import { projectRequestsReducer } from 'modules/project/store/projectRequests';
import { projectsTimeReportReducer } from 'modules/projectTimeReport/store/projectTimeReport';
import { projectTasksReducer } from 'modules/project/store/projectTasks';
import { projectTasksTimelogReducer } from 'modules/project/store/projectTasksTimelog';
import { projectCreditsReducer } from 'modules/project/store/projectCredits';
import { projectCreditHistoryReducer } from 'modules/project/store/projectCreditHistory';
import { projectBudgetReportReducer } from 'modules/project/store/projectBudgetReport';
import projectSelect from 'modules/project/store/projectSelect-slice';
import reportUserPerformance from 'modules/report/store/reportUserPerformance-slice';
import { requestsReducer } from 'modules/request/store/request';
import { requestTimelogReducer } from 'modules/request/store/requestTimelog';
import { tasksReducer } from 'modules/tasks/store/task';
import { taskTimelogReportReducer } from 'modules/tasks/store/taskTimelogReport';
import groups from 'modules/groups/store/groups-slice';
import content from 'modules/content/store/content-slice';
import { timelogReportReducer } from 'modules/timelogReport/store/timelogReport';
import { profileTimelogReducer } from 'modules/contact/store/profileTimelog';
import {
  profileClockReportReducer,
  profileTaskOverdueReducer,
  profileRequestOverdueReducer,
} from 'modules/contact/store/profileReports';
import { projectTimelogReportReducer } from 'modules/project/store/projectTimelogReport';
import dashboardFailedPayments from 'modules/dashboard/store/dashboardFailedPayments-slice';
import dashboardUserPerformance from 'modules/dashboard/store/dashboardUserPerformance-slice';
import { dashboardTasksReducer } from 'modules/dashboard/store/dashboardTasks';
import { requestExportReducer } from 'modules/request/store/requestExport';

import activeLogs from './container/activeLogs/activeLogs-slice';
import weeklyLogs from './container/weeklyLogs/weeklyLogs-slice';
import auth from './container/auth/auth-slice';
import versionUpdate from './container/versionUpdate/versionUpdate-slice';
import globalLog from './container/globalLog/globalLog-slice';
import globalTaskModal from './container/globalTaskModal/globalTaskModal-slice';
import globalClientModal from './container/globalClientModal/globalClientModal-slice';
import resources from './container/resources/resourcesSlice';
import teamActivity from './container/teamActivity/teamActivity-slice';
import teamTaskActivity from './container/teamTaskActivity/teamTaskActivity-slice';

export default {
  contacts,
  customers,
  customerSelect,
  groups,
  inbox,
  auth,
  projectSelect,
  tableRequests: requestsReducer,
  tableRequestsExport: requestExportReducer,
  requestTimelog: requestTimelogReducer,
  tableTasks: tasksReducer,
  taskTimelogReport: taskTimelogReportReducer,
  tableProjectTasks: projectTasksReducer,
  tableProjectRequests: projectRequestsReducer,
  tableProjects: projectsReducer,
  projectsTimeReport: projectsTimeReportReducer,
  tableProjectTasksTimelog: projectTasksTimelogReducer,
  tableProjectCredits: projectCreditsReducer,
  tableProjectCreditHistory: projectCreditHistoryReducer,
  projectBudgetReport: projectBudgetReportReducer,
  clients: clientsReducer,
  activeLogs,
  weeklyLogs,
  teamActivity,
  teamTaskActivity,
  timelogReport: timelogReportReducer,
  profileTimelog: profileTimelogReducer,
  profileClockReport: profileClockReportReducer,
  profileTaskOverdue: profileTaskOverdueReducer,
  profileRequestOverdue: profileRequestOverdueReducer,
  projectTimelogReport: projectTimelogReportReducer,
  reportUserPerformance,
  globalLog,
  globalTaskModal,
  globalClientModal,
  content,
  dashboardFailedPayments,
  dashboardUserPerformance,
  dashboardTasks: dashboardTasksReducer,
  versionUpdate,
  resources,
};
